<template>
    <div class="mural">
      <div class="tb-form-group">
        <label class="tb-label">Cycle speed</label>

        <input
          type="number"
          class="tb-input"
          :value="getNiceTime(getField('displayTime'))"
          data-entity="producer-editor-displayTime"
          data-test="display-editor-cycleSpeed"
          @keyup.right.stop
          @keyup.left.stop
          @change="setNiceTime('displayTime', $event.target.value)"
        >

        <span class="help-text">Range: 1 - 100 seconds</span>
      </div>

      <div class="tb-form-group">
        <div
          class="tb-checkbox"
          data-entity="producer-editor-toggleShowPostDetail"
        >
          <input type="checkbox" id="showPostDetail" v-on:change="setField('showPostDetail', $event.target.checked)" :checked="getField('showPostDetail')" 
          data-test="display-editor-showPostDetail">
          <label class="checkbox" for="showPostDetail">Show pop-up animation</label>
        </div>
      </div>

      <template v-if="getField('showPostDetail')">
        <div class="tb-form-group">
          <label class="tb-label">Post detail cycle speed</label>

          <input
            type="number"
            class="tb-input"
            min="1"
            max="100"
            :value="getNiceTime(getField('postDetailCycleTime'))"
            data-entity="producer-editor-postDetailCycleTime"
            data-test="producer-editor-cycleSpeed-postDetail"
            @keyup.right.stop
            @keyup.left.stop
            @change="setNiceTime('postDetailCycleTime', $event.target.value)"
          >

          <span class="help-block">Range: 1 - 100 seconds.</span>
        </div>

        <div class="tb-form-group">
          <label class="tb-label">Post detail display time</label>

          <input
            type="number"
            class="tb-input"
            min="1"
            max="100"
            :value="getNiceTime(getField('postDetailDisplayTime'))"
            data-entity="producer-detail-postDetailDisplayTime"
            data-test="display-editor-postDetail-displayTime"
            @keyup.right.stop
            @keyup.left.stop
            @change="setNiceTime('postDetailDisplayTime', $event.target.value)"
          >

          <span class="help-block">Range: 1 - 100 seconds.</span>
        </div>
      </template>

      <background
        :item="item"
        :theme="theme"
        class="margin-bottom-md"
      />
    </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';
import BackgroundComponent from '../shared/Background.vue';

export default {
  mixins: [editingMixins],
  components: {
    background: BackgroundComponent,
  },
  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
};
</script>
